// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge{--badge-size:5em;align-items:center;border-radius:100%;box-sizing:content-box;display:inline-flex;font-weight:500;height:5em;height:var(--badge-size);justify-content:center;line-height:1.1;padding:.5em;position:absolute;width:5em;width:var(--badge-size)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
